import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// CHANGED: Switched Firebase config to PROD project (polystox-8dea9)
const firebaseConfig = {
  apiKey: "AIzaSyBItsdqNsSzVsFQAAh-sRS78nhjeNH6fG0",
  authDomain: "polystox-8dea9.firebaseapp.com",
  projectId: "polystox-8dea9",
  storageBucket: "polystox-8dea9.firebasestorage.app",
  messagingSenderId: "186604753030",
  appId: "1:186604753030:web:d696d43b3925eb4c580107",
  measurementId: "G-Z869M2B2LQ",
};

// const firebaseConfig = {
//   apiKey: "AIzaSyCizVg7-ueMtGcHrT911WSvbFyeY3iDUA0",
//   authDomain: "polystox-dev.firebaseapp.com",
//   databaseURL: "https://polystox-dev-default-rtdb.firebaseio.com",
//   projectId: "polystox-dev",
//   storageBucket: "polystox-dev.appspot.com",
//   messagingSenderId: "194922638618",
//   appId: "1:194922638618:web:3e028d7e417f0db41bd0a3",
//   measurementId: "G-121GT2MKJN"
// };

// Firebase initialize
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { app, db, firebaseConfig };
